module.exports = __webpack_public_path__ + "static/media/zadania-matematyczne.7ae7d205.png";